import { ApolloProvider } from '@apollo/client';
import React from 'react';
// eslint-disable-next-line import/extensions
import { useRouter } from 'next/router';
import { useApollo } from '../client.js';
import { Toolbar } from './Toolbar/index.js';
import { getConfig } from '../config/index.js';
export function FaustProvider(props) {
    const { pageProps, children } = props;
    const { experimentalToolbar } = getConfig();
    const router = useRouter();
    const apolloClient = useApollo(pageProps);
    return (React.createElement(ApolloProvider, { client: apolloClient },
        experimentalToolbar && (React.createElement(Toolbar, { key: `faust-toolbar-${router.asPath}`, 
            // eslint-disable-next-line no-underscore-dangle
            seedNode: pageProps.__SEED_NODE__ })),
        children));
}
